export default __webpack_public_path__ + "static/media/benchmark_segment.8f3c7d76.svg";